import type { Vault } from '@/types/vault'

export function isVaultInCurators(vault: Vault, curators: string[]): boolean {
  if (curators.length === 0) return true
  if (!vault.curator) return false
  if (vault.curator.name.includes('/')) {
    const vaultCurators = vault.curator.name.split('/')
    return curators.some((curator) => vaultCurators.includes(curator))
  }
  return curators.includes(vault.curator?.name)
}
